export * from './warning_icon';
